
import type { NameStyle, NameLength } from './types';

export const NAME_STYLES: NameStyle[] = ['Modern', 'Creative', 'Luxury', 'Playful'];
export const NAME_LENGTHS: NameLength[] = ['Short', 'Medium', 'Long'];
export const MAX_FREE_GENERATIONS = 2;

// --- Admin Configuration ---
export const ADMIN_EMAILS = ['burimbekteshi531@gmail.com'];

// --- Affiliate Link Constants ---
// Reading from Vite's import.meta.env (supports both legacy and new Impact env vars)
export const IMPACT_AFFILIATE_URL_PREFIX = import.meta.env.VITE_IMPACT_AFFILIATE_URL_PREFIX || import.meta.env.VITE_AWIN_AFFILIATE_URL_PREFIX || 'https://namecheap.pxf.io/c/241445/511355/5618?u=';
export const AWIN_AFFILIATE_URL_PREFIX = IMPACT_AFFILIATE_URL_PREFIX;
export const NAMECHEAP_SEARCH_URL_PREFIX = import.meta.env.VITE_NAMECHEAP_SEARCH_URL_PREFIX || 'https://www.namecheap.com/domains/registration/results/?domain=';

// --- Subscription Plan Constants ---
// Plan IDs are now loaded from environment variables for production.
export const SUBSCRIPTION_PLANS = {
  Monthly: {
    id: import.meta.env.VITE_PAYPAL_MONTHLY_PLAN_ID || '',
    name: 'Monthly',
    price: '$14.99/month',
  },
  Yearly: {
    id: import.meta.env.VITE_PAYPAL_YEARLY_PLAN_ID || '',
    name: 'Yearly',
    price: '$99.99/year',
  },
};